export enum UiSize {
  SM = 'sm',
  MD = 'md',
  LG = 'lg',
  XL = 'xl',
}

export enum UiTheme {
  DEFAULT = 'default',
  PRIMARY = 'primary',
  SECOND = 'second',
  SUCCESS = 'success',
  DANGER = 'danger',
}

export enum UiAlertTheme {
  INFO = 'info',
  WARNING = 'warning',
  ERROR = 'error',
  SUCCESS = 'success',
}

export enum UiDirection {
  VERTICAL = 'vertical',
  HORIZONTAL = 'horizontal',
}
